import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";

import { StyledWrapper } from "./styles";
import { MathOption } from "../MathOption";
import { OperatorDescriptionKinds } from "../../constanst";
import type { OperatorDescriptions_OperatorDescription } from "@smartsuite/automation-engine-api";
import { isAvailableOperator } from "../../utils";

interface MathOperationsProps {
  operatorDescriptions?: OperatorDescriptions_OperatorDescription[];

  onChange: (value: OperatorDescriptionKinds) => void;
}

/* eslint-disable import/no-unused-modules */
export const MathOperations: FunctionComponent<MathOperationsProps> = ({
  operatorDescriptions,
  onChange,
}) => {
  return (
    <StyledWrapper>
      {/* TODO: Add translates */}
      <Text
        className="math-operations-title"
        color="secondary"
        size="xs"
        weight="semibold"
      >
        Math operations
      </Text>
      {isAvailableOperator(
        OperatorDescriptionKinds.MATH_ADD,
        operatorDescriptions,
      ) && (
        <MathOption
          type={OperatorDescriptionKinds.MATH_ADD}
          onClick={onChange}
        />
      )}
      {isAvailableOperator(
        OperatorDescriptionKinds.MATH_SUBTRACT,
        operatorDescriptions,
      ) && (
        <MathOption
          type={OperatorDescriptionKinds.MATH_SUBTRACT}
          onClick={onChange}
        />
      )}
      {isAvailableOperator(
        OperatorDescriptionKinds.MATH_MULTIPLY,
        operatorDescriptions,
      ) && (
        <MathOption
          type={OperatorDescriptionKinds.MATH_MULTIPLY}
          onClick={onChange}
        />
      )}
      {isAvailableOperator(
        OperatorDescriptionKinds.MATH_DIVIDE,
        operatorDescriptions,
      ) && (
        <MathOption
          type={OperatorDescriptionKinds.MATH_DIVIDE}
          onClick={onChange}
        />
      )}
    </StyledWrapper>
  );
};
